
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_60556_6331)","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M5.267 10.733L1.824 9.464a.495.495 0 010-.928l3.443-1.27 1.269-3.442a.495.495 0 01.928 0l1.27 3.443 3.442 1.269a.495.495 0 010 .928l-3.443 1.27-1.269 3.442a.494.494 0 01-.928 0l-1.27-3.443zM11 1v3M14 4.5v2M9.5 2.5h3M13 5.5h2"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_60556_6331"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    